import { render, staticRenderFns } from "./AccountantNoRequisitions.vue?vue&type=template&id=89d32902&"
import script from "./AccountantNoRequisitions.vue?vue&type=script&lang=js&"
export * from "./AccountantNoRequisitions.vue?vue&type=script&lang=js&"
import style0 from "./AccountantNoRequisitions.vue?vue&type=style&index=0&id=89d32902&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports